export const shadows = {
  outline: "0 0 0 2px #FF9A9B",
};
